export default __webpack_public_path__ + "static/media/45.82bf54c0.jpg";